import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {TranslateDirective, TranslatePipe} from "@ngx-translate/core";


@Component({
    selector: 'app-majority-dialog-component',
    templateUrl: './majority-dialog-component.component.html',
    styleUrls: ['./majority-dialog-component.component.css'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatDialogModule,
    MatButtonModule,
    TranslatePipe, TranslateDirective
]
})
export class MajorityDialogComponentComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MajorityDialogComponentComponent>) {
  }

  ngOnInit(): void {
  }

  yes(): void {
    this.dialogRef.close(true);
  }

  no() {
    this.dialogRef.close(false);
  }

}
